<template>
  <div class="landing-page">
    <div class="container">
      <container title="More">
        <div class="is-size-5 container2 desktop">
          <topic class="topic" v-for="topic in content" :key="topic.icon" :icon='topic.icon' :text='topic.name' :action='()=> redirect(topic.url)'/>
        </div>
        </container>
    </div>
  </div>
</template>

<script>

import container from "@/components/structure/Section.vue"
import topic from "@/components/structure/Topic.vue"

export default {
  name: 'About',
  components: {
    container,
    topic
  },
  data() {
    return {
      content: [
        {icon: 'rendering.svg', name:'Press Kit', url: 'https://drive.google.com/open?id=123ae6_YmN_oKretDTonQ2R6-WqmWxE6W'},
        {icon: 'gmail.svg', name:'Contact', url: 'mailto:joaocsf.se@gmail.com'},
      ]
    }
  },
  methods: {
    redirect(url) {
      window.location = url;
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.landing-page{
  margin: 0px;
  width: 100%;
  position: relative;
  color: white;
  background: var(--dark-color);
  background: var(--dark-color);
}


@media screen and (min-width:601px){
  .desktop{
    flex-direction: column;
  }
}

@media screen and (max-width:601px){
  .desktop{
    flex-direction: column !important;
    justify-content: center;
    align-items: center;
  }
}

.container div:last-child{
  padding-bottom: 0.5em;
}

.container2{
  justify-content: center;
  display: flex;
  flex-direction: row;
}

.topic{
  margin: 1em;
  margin-top: 0;
  font-size: 1.3em;
  width: 130px;
}

.col{
  height: 50%;
  display: flex;
}
.vertical{
  flex-direction: column;
}
.text{
  width:100%;
}

.align-bottom{
  align-items: flex-end;
  display: flex;
}

.align-top{
  align-items: flex-start;
  display: flex;
}

.name{
  font-family: 'caladea';
  font-style: italic;
  font-weight: bold;
}

.profession{
  color: var(--second-color);
  font-family: 'franklin gothic medium';
}

.quote{
  color: var(--second-color);
  opacity: 0.8;
  font-family: 'franklin gothic medium';
}


@media screen and (min-width:601px){
  .name{
    font-size: 5em;
  }
  .profession{
    font-size: 3em;
  }
  .quote{
    font-size: 1.5em;
  }
}

@media screen and (max-width:600px){
  .name{
    font-size: 4em;
  }
  .profession{
    font-size: 2.4em;
  }
  .quote{
    font-size: 1.5em;
  }
}

.divider.s4{
  background: linear-gradient(2deg, var(--dark-color2) 50%, #1F3764 51%);
  background: linear-gradient(2deg, var(--bright-color) 50%, var(--dark-color) 51%);
  background: linear-gradient(2deg, #1F3764 50%, var(--dark-color) 51%);
  background: linear-gradient(2deg, var(--second-color) 50%, var(--dark-color) 51%);
}

</style>
